import { serverCall } from "../modules/ServerComms";

function getretrieveRefundIssueResolutions(
  queryParams,
  theCallback,
  theJWTToken
) {
  const {
    filter,
    search,
    page,
    limit,
    sort,
    jobType,
    refund,
    dateLowerRange,
    dateUpperRange,
  } = queryParams;
  const url = `/api/admin/issuesAndResolutions/refunds?page=${page}&limit=${limit}${filter ? `&filter=${filter}` : ""
    }${sort ? `&${sort}` : ""}${search ? `&search=${search}` : ""}${jobType ? `&jobType=${jobType}` : ""
    }${refund ? `&refund=${refund}` : ""}${dateLowerRange ? `&dateLowerRange=${dateLowerRange}` : ""
    }${dateUpperRange ? `&dateUpperRange=${dateUpperRange}` : ""}`;
  const handleCallAPI = (resStatus, resJson) => {
    var responseString;

    if (resStatus == "400" || resStatus == 400) {
      if (resJson.errorString == "nouserdata") {
        responseString = "ERROR: NO USER DATA";
      } else if (resJson.errorString == "nouserwiththatemail") {
        responseString = "ERROR: USER NOT FOUND";
      } else if (resJson.errorString == "usernotactive") {
        responseString = "ERROR: USER NOT ACTIVE";
      } else if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "nojobsfound") {
        responseString = "ERROR: NO JOBS FOUND";
      } else if (resJson.errorString == "invalidfilter") {
        responseString = "ERROR: INVALID FILTER";
      } else if (resJson.errorString == "invalidsearch") {
        responseString = "ERROR: INVALID SEARCH";
      } else if (resJson.errorString == "invalidsorts") {
        responseString = "ERROR: INVALID SORT";
      } else if (resJson.errorString == "invalidpage") {
        responseString = "ERROR: INVALID PAGE";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (resStatus == "401" || resStatus == 401) {
      if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "userblocked") {
        responseString = "ERROR: USER BLOCKED";
      } else if (resJson.errorString == "outdatedappversion") {
        responseString = "ERROR: OUTDATED VERSION";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (
      resStatus == "504" ||
      resStatus == 504 ||
      resStatus == "502" ||
      resStatus == 502
    ) {
      responseString = "ERROR: TIMEOUT";
      return theCallback(resStatus, responseString, false);
    } else if (resStatus == "200" || resStatus == 200) {
      if (resJson.successString == "usersfound") {
      }

      return theCallback(resStatus, responseString, resJson);
    }
  };
  serverCall("GET", url, null, handleCallAPI, theJWTToken);
}




function getretrieveDriverPenaltiesIssueResolutions(
  queryParams,
  theCallback,
  theJWTToken
) {
  const {
    filter,
    search,
    page,
    limit,
    sort,
    jobType,
    penalty,
    dateLowerRange,
    dateUpperRange,
    scheduledDateLowerRange,
    scheduledDateUpperRange,
  } = queryParams;
  const url = `/api/admin/issuesAndResolutions/driverPenalties?page=${page}&limit=${limit}${filter ? `&filter=${filter}` : ""
    }${sort ? `&${sort}` : ""}${search ? `&search=${search}` : ""}${jobType ? `&jobType=${jobType}` : ""
    }${penalty ? `&penalty=${penalty}` : ""}${dateLowerRange ? `&dateLowerRange=${dateLowerRange}` : ""
    }${dateUpperRange ? `&dateUpperRange=${dateUpperRange}` : ""}${scheduledDateLowerRange ? `&scheduledDateLowerRange=${scheduledDateLowerRange}` : ""}${scheduledDateUpperRange ? `&scheduledDateUpperRange=${scheduledDateUpperRange}` : ""}`;
  const handleCallAPI = (resStatus, resJson) => {
    var responseString;

    if (resStatus == "400" || resStatus == 400) {
      if (resJson.errorString == "nouserdata") {
        responseString = "ERROR: NO USER DATA";
      } else if (resJson.errorString == "nouserwiththatemail") {
        responseString = "ERROR: USER NOT FOUND";
      } else if (resJson.errorString == "usernotactive") {
        responseString = "ERROR: USER NOT ACTIVE";
      } else if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "nojobsfound") {
        responseString = "ERROR: NO JOBS FOUND";
      } else if (resJson.errorString == "invalidfilter") {
        responseString = "ERROR: INVALID FILTER";
      } else if (resJson.errorString == "invalidsearch") {
        responseString = "ERROR: INVALID SEARCH";
      } else if (resJson.errorString == "invalidsorts") {
        responseString = "ERROR: INVALID SORT";
      } else if (resJson.errorString == "invalidpage") {
        responseString = "ERROR: INVALID PAGE";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (resStatus == "401" || resStatus == 401) {
      if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "userblocked") {
        responseString = "ERROR: USER BLOCKED";
      } else if (resJson.errorString == "outdatedappversion") {
        responseString = "ERROR: OUTDATED VERSION";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (
      resStatus == "504" ||
      resStatus == 504 ||
      resStatus == "502" ||
      resStatus == 502
    ) {
      responseString = "ERROR: TIMEOUT";
      return theCallback(resStatus, responseString, false);
    } else if (resStatus == "200" || resStatus == 200) {
      if (resJson.successString == "usersfound") {
      }

      return theCallback(resStatus, responseString, resJson);
    }
  };
  serverCall("GET", url, null, handleCallAPI, theJWTToken);
}


function driverCancellationPenalty(payload, theCallback, theJWTToken) {
  const API_URL = `/api/admin/driverCancellationPenaltyDecision`;
  serverCall(
    "POST",
    API_URL,
    payload,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

function refundPaymentDecision(payload, theCallback, theJWTToken) {
  const API_URL = `/api/admin/refundPaymentDecision`;
  serverCall(
    "POST",
    API_URL,
    payload,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

function addJobNotes(payload, theCallback, theJWTToken) {
  const API_URL = `/api/admin/addNote`;
  serverCall(
    "POST",
    API_URL,
    payload,
    function (resStatus, resJson) {
      let responseString;
      if (resStatus == "200" || resStatus == 200) {
        if (resJson.message) {
          responseString = resJson.message;
        }
        return theCallback(resStatus, responseString, resJson);
      } else {
        return theCallback(resStatus, resJson.message, false);
      }
    },
    theJWTToken
  );
}

function getJobNotes(queryParams, theCallback, theJWTToken) {
  const { jobId } = queryParams;
  const url = `/api/admin/notes?jobId=${jobId}`;
  const handleCallAPI = (resStatus, resJson) => {
    var responseString;

    if (resStatus == "400" || resStatus == 400) {
      // jobsfound | nouserdata nouserwiththatemail unauthorised nojobsfound usernotactive

      if (resJson.errorString == "nouserdata") {
        responseString = "ERROR: NO USER DATA";
      } else if (resJson.errorString == "nouserwiththatemail") {
        responseString = "ERROR: USER NOT FOUND";
      } else if (resJson.errorString == "usernotactive") {
        responseString = "ERROR: USER NOT ACTIVE";
      } else if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "nojobsfound") {
        responseString = "ERROR: NO JOBS FOUND";
      } else if (resJson.errorString == "invalidfilter") {
        responseString = "ERROR: INVALID FILTER";
      } else if (resJson.errorString == "invalidsearch") {
        responseString = "ERROR: INVALID SEARCH";
      } else if (resJson.errorString == "invalidsorts") {
        responseString = "ERROR: INVALID SORT";
      } else if (resJson.errorString == "invalidpage") {
        responseString = "ERROR: INVALID PAGE";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (resStatus == "401" || resStatus == 401) {
      if (resJson.errorString == "unauthorised") {
        responseString = "ERROR: USER NOT AUTHORISED";
      } else if (resJson.errorString == "userblocked") {
        responseString = "ERROR: USER BLOCKED";
      } else if (resJson.errorString == "outdatedappversion") {
        responseString = "ERROR: OUTDATED VERSION";
      } else {
        responseString = "ERROR: UNKNOWN";
      }

      return theCallback(resStatus, responseString, resJson);
    } else if (
      resStatus == "504" ||
      resStatus == 504 ||
      resStatus == "502" ||
      resStatus == 502
    ) {
      responseString = "ERROR: TIMEOUT";
      return theCallback(resStatus, responseString, false);
    } else if (resStatus == "200" || resStatus == 200) {
      if (resJson.successString == "usersfound") {
      }

      return theCallback(resStatus, responseString, resJson);
    }
  };
  serverCall("GET", url, null, handleCallAPI, theJWTToken);
}


export {
  getretrieveRefundIssueResolutions,
  getretrieveDriverPenaltiesIssueResolutions,
  driverCancellationPenalty,
  refundPaymentDecision,
  addJobNotes,
  getJobNotes
};
